import inputBaseClasses from "@mui/material/InputBase/inputBaseClasses";
import outlinedInputClasses from "@mui/material/OutlinedInput/outlinedInputClasses";
import iconButtonClasses from "@mui/material/IconButton/iconButtonClasses";
import inputLabelClasses from "@mui/material/InputLabel/inputLabelClasses";
import formHelperTextClasses from "@mui/material/FormHelperText/formHelperTextClasses";
export const MuiInputBaseTheme = (dt) => {
    return {
        styleOverrides: {
            root: {
                color: dt.color.onSurface.key,
                background: dt.color.surface.key,
                [`&.${inputBaseClasses.multiline}`]: {
                    padding: 0,
                },
                [`&.${inputBaseClasses.input}`]: {
                    padding: 0,
                },
                [`&.${inputBaseClasses.root}.${inputBaseClasses.disabled}`]: {
                    fieldset: {
                        color: dt.cta.outlined.color.text.primary.disabled,
                    },
                    ".PixelIcon": {
                        opacity: dt.opacity.states.disabled.content,
                    },
                },
                [`&.${inputBaseClasses.adornedStart}`]: {
                    paddingLeft: dt.inset.squish.medium.horizontal,
                    [`.${outlinedInputClasses.input}`]: {
                        paddingLeft: dt.inline.small,
                    },
                    ".PixelIcon:not([class*='MuiSvgIcon-color'])": {
                        backgroundColor: dt.color.onSurface.variant,
                    },
                },
                [`&.${inputBaseClasses.adornedEnd}`]: {
                    paddingRight: dt.inset.squish.medium.horizontal,
                    [`.${outlinedInputClasses.input}`]: {
                        paddingRight: dt.inline.small,
                    },
                    ".PixelIcon:not([class*='MuiSvgIcon-color'])": {
                        backgroundColor: dt.color.onSurface.variant,
                    },
                },
                ".PixelIcon": {
                    width: dt.icon.size.large,
                    height: dt.icon.size.large,
                },
                [`.${inputBaseClasses.inputSizeSmall}[class]`]: {
                    [`&:not(.${inputBaseClasses.inputMultiline})`]: {
                        height: dt.input.dense,
                        lineHeight: dt.input.dense,
                    },
                    [`& + .${iconButtonClasses.root}`]: {
                        minHeight: dt.button.small,
                        minWidth: dt.button.small,
                        ".PixelIcon": {
                            height: dt.icon.size.small,
                            width: dt.icon.size.small,
                        },
                    },
                },
            },
        },
    };
};
export const MuiOutlinedInputTheme = (dt) => {
    return {
        styleOverrides: {
            root: {
                fieldset: {
                    borderColor: dt.color.outline,
                    borderRadius: dt.input.shape.borderRadius,
                    borderWidth: dt.input.shape.border,
                },
                legend: {
                    position: "fixed",
                    left: "-999rem",
                    top: "-999rem",
                },
                [`.${outlinedInputClasses.input}`]: {
                    boxSizing: "border-box",
                    padding: `0 ${dt.inset.squish.medium.horizontal}`,
                    [`&:not(.${inputBaseClasses.inputMultiline})`]: {
                        height: dt.input.default,
                        lineHeight: dt.input.default,
                    },
                    [`&.${inputBaseClasses.inputMultiline}`]: {
                        paddingTop: "12px",
                        paddingBottom: "12px",
                    },
                    "&[class][class]::placeholder": {
                        opacity: 1,
                        color: dt.color.onSurface.variant,
                    },
                },
                [`&:hover fieldset, .${inputBaseClasses.input}:is(.Pxl-demo-hover, [data-demostate=hover]) ~ fieldset`]: {
                    borderColor: dt.color.onSurface.key,
                    borderWidth: dt.input.shape.border,
                },
                [`.${inputBaseClasses.input}:focus ~ fieldset, .${inputBaseClasses.input}:is(.Pxl-demo-focus, [data-demostate=focus]) ~ fieldset`]: {
                    borderColor: dt.cta.outlined.color.border.primary.focus,
                    borderWidth: dt.input.shape.border,
                    boxShadow: dt.state.focus.primary,
                },
                [`&.${inputBaseClasses.error}[class] fieldset`]: {
                    borderColor: dt.cta.outlined.color.border.signal.error.default,
                },
                "&.MuiInputBase-colorSuccess[class] fieldset": {
                    borderColor: dt.cta.outlined.color.border.signal.success.default,
                },
                [`&.${inputBaseClasses.root}.${inputBaseClasses.disabled} fieldset`]: {
                    borderColor: dt.cta.outlined.color.border.primary.disabled,
                },
            },
        },
    };
};
export const MuiTextFieldTheme = (dt) => {
    return {
        defaultProps: {
            InputLabelProps: {
                shrink: true,
            },
        },
        styleOverrides: {
            root: {
                [`.${inputLabelClasses.root}`]: {
                    position: "static",
                    transform: "none",
                    marginBottom: 0,
                    "&.Mui-disabled": {
                        color: dt.cta.outlined.color.text.primary.disabled,
                    },
                    [`& + .${inputBaseClasses.root}`]: {
                        marginTop: dt.stacked.xSmall,
                    },
                },
                [`.${inputBaseClasses.root}`]: {
                    marginBottom: 0,
                    [`& + .${formHelperTextClasses.root}[class]`]: {
                        marginTop: dt.stacked.xSmall,
                    },
                    fieldset: {
                        top: 0,
                    },
                    legend: {
                        position: "fixed",
                        left: "-9vmax",
                        top: "-9vmax",
                    },
                },
            },
        },
    };
};
